module.exports = __webpack_public_path__ + "static/threat-93217511521ed957b7c50d9ee04d235d.jpg";